export function CompanyInfoPage() {
    return <div>
        CompanyInfoPage
    </div>
}
